import { useParams } from 'react-router-dom';
import { useStorefrontTenantSlug } from '@/contexts/StorefrontTenantContext';

export const useStorePath = () => {
    const tenantSlug = useStorefrontTenantSlug();
    const { storeSlug, templateId } = useParams<{ storeSlug?: string; templateId?: string }>();

    const getStorePath = (path: string) => {
        // Handle external or anchor links
        if (!path || path === '#' || path.startsWith('http') || path.startsWith('//') || path.startsWith('mailto:') || path.startsWith('tel:')) {
            return path || '#';
        }

        const cleanPath = path.startsWith('/') ? path : `/${path}`;

        if (tenantSlug) {
            return cleanPath === '/' ? '/' : cleanPath;
        }

        if (storeSlug) {
            return `/store/${storeSlug}${cleanPath}`;
        }

        if (templateId) {
            return `/demo-store/${templateId}${cleanPath}`;
        }

        return path;
    };

    return { getStorePath };
};
